import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';

import { LoginService } from '../../services/login.service';

@Component({
  selector: 'app-auth-callback',
  templateUrl: './auth-callback.component.html',
})
export class AuthCallbackComponent implements OnInit {

  error: string | null = null;

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private loginService: LoginService,
  ) {}

  ngOnInit(): void {
    const code  = this.route.snapshot.queryParamMap.get('code');
    const state = this.route.snapshot.queryParamMap.get('state');
    const error = this.route.snapshot.queryParamMap.get('error');

    const isPopup  = !!(window.opener && window.opener !== window);
    const isIframe = !isPopup && window.parent !== window;

    // eslint-disable-next-line no-console
    console.log('[authCallback] loaded', { isPopup, isIframe, code: !!code, state: !!state, error, href: window.location.href });

    if (isPopup || isIframe) {
      // Running inside a popup or a hidden silent-auth iframe: relay code+state
      // to the parent window/frame and stop. The parent (which retains the PKCE
      // verifier in sessionStorage) handles the token exchange.
      const target = isPopup ? window.opener : window.parent;
      const errMsg = error || (!code || !state ? 'missing_params' : null);
      target.postMessage(
        { type: 'AUTH0_CODE', code, state, error: errMsg },
        window.location.origin
      );
      if (isPopup) window.close();
      return;
    }

    // Direct navigation (fallback redirect flow or external link)
    if (error || !code || !state) {
      this.error = error || 'missing_params';
      this.router.navigate(['/login'], { queryParams: { error: this.error } });
      return;
    }

    this.loginService.handleAuth0Callback(code, state).subscribe({
      next: () => this.router.navigate(['/']),
      error: err => {
        this.error = err?.message || 'auth_failed';
        this.router.navigate(['/login'], { queryParams: { error: this.error } });
      },
    });
  }
}
